// CSV formula-injection guard — the client twin of server/utils/csvSafe.js
// (security hardening 2026-09-05). A cell whose text starts with = + - @ (or a
// tab/CR that lets one follow) is evaluated as a FORMULA when the exported file
// is opened in Excel/LibreOffice, and CSV quoting does not help — the quotes
// are stripped before evaluation. Prefixing a single quote turns it into
// literal text. Only STRING cells are touched: numbers and booleans pass
// through, so a negative cost in a numeric column stays a number (pass it as a
// number, not a pre-formatted string).
//
// TRIGGER must stay byte-identical to the server copy — test/fileServing.test.js
// on the server pins the two regex sources against each other.
export const TRIGGER = /^[=+\-@\t\r]/;

export function csvSafeCell(v) {
  if (v == null) return '';
  if (typeof v === 'number' || typeof v === 'boolean') return v;
  const s = String(v);
  return TRIGGER.test(s) ? `'${s}` : s;
}

// Apply to an array-of-arrays before it is serialized to CSV text.
export function csvSafeRows(rows) {
  return rows.map(r => (Array.isArray(r) ? r.map(csvSafeCell) : r));
}
